import Swiper, { A11y, Autoplay, EffectFade, Mousewheel, Pagination, Scrollbar } from 'swiper';
Swiper.use([Mousewheel, A11y, EffectFade, Autoplay, Pagination, Scrollbar]);
document.addEventListener('DOMContentLoaded', (event) => {
    const sliders = document.querySelectorAll('[data-notif-bar-custom-timing="true"][data-use-marquee="false"]');
    if (sliders.length > 0) {
        [...sliders].forEach((sliderItem) => {
            const options = {
                loop: true,
                autoplay: {
                    disableOnInteraction: false,
                },
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                speed: 1000
            };
            const swiper = new Swiper(sliderItem, options);
        });
    }
});
